export const Session = function () {};

Session.clean = function () {
    Session.current = function () {
        return false;
    };
    Session.isClosing = false;
};

Session.closing = function () {
    Session.isClosing = true;
};

// Assigns the handler to current - note that handler is not called here
Session.start = function (handler) {
    Session.current(new Error('Only one instance of auth can happen at a time'));
    Session.current = handler;
};

// Call current, which will close the mobile web window
Session.onRedirectUri = function (token) {
    if (Session.current(null, token)) {
        Session.clean();
    }
};

export default Session;
